module.exports = "pegasus/assets/blocks/header-7-tech.png";